import React from 'react';
import classNames from 'classnames';
import { Badge } from 'components/badges';
import { formatSchedule } from 'utils/date';
import { formatReminderActiveWindow } from 'utils/reminders';

export default function ReminderListItem({ reminder, isSelected, onSelect, settings }) {
  const reminderId = reminder._id;
  const scheduleText = formatSchedule(reminder, settings, true);
  const activeWindowText = formatReminderActiveWindow(reminder, settings);

  return (
    <div
      className={classNames(
        "flex items-center p-4 rounded-md border cursor-pointer transition-colors",
        {
          'border-indigo-500 bg-indigo-900/20': isSelected,
          'border-gray-700 bg-gray-800 hover:bg-gray-700': !isSelected
        }
      )}
      onClick={() => onSelect(reminderId)}
    >
      <div className={classNames(
        "h-4 w-4 rounded-full border flex items-center justify-center",
        {
          'border-indigo-500': isSelected,
          'border-gray-500': !isSelected
        }
      )}>
        {isSelected && (
          <div className="h-2 w-2 rounded-full bg-indigo-500" />
        )}
      </div>
      <div className="ml-3">
        <div className="flex items-center gap-2">
          <p className="text-sm font-medium text-white">{reminder.subject}</p>
          {reminder.worker && (
            <Badge size="sm" color="blue">
              Worker assigned
            </Badge>
          )}
        </div>
        <p className="text-xs text-gray-400">{scheduleText}</p>
        {activeWindowText && <p className="text-xs text-gray-500">{activeWindowText}</p>}
      </div>
    </div>
  );
}
